import Notification, { NotificationType } from 'components/notifiers/Notification';
import strings from '../../../../../../strings/strings.json';
import { WarningNotifierSlim } from 'components/notifiers/WarningNotifierSlim';
import { Activity } from 'models/Activity';
import { Course } from 'models/Course';
import { CreateFileSource } from 'models/inputModels/CreateTaskRequest';

export type EditTaskFormProps = {
    task: Activity;
    returnToCourseStructure: () => void;
};

export type FileCardComponentData = {
    fileName: string;
    fileDate: Date;
    filePath: string;
    fileSource: CreateFileSource;
};

export function EditModeSaveNotification(): JSX.Element {
    return (
        <Notification
            notificationType={NotificationType.WARNING}
            title={strings.editModeNotifiers.savedForReview}
            maxWidth="100%"
        />
    );
}

export function LastActivityInModuleWarning(): JSX.Element {
    return <WarningNotifierSlim description={strings.editModeNotifiers.lastActivityInModule} />;
}

export function ModuleOnlyHasOneTask(course: Course, moduleId: string): boolean {
    return course.modules.find((m) => m.id === moduleId)?.activities.length === 1;
}

export function SavedSuccessfullyNotification() {
    return <Notification notificationType={NotificationType.SUCCESS} title={strings.general.saveSuccess} />;
}
